import { render, staticRenderFns } from "./mine.vue?vue&type=template&id=2bcd7318&scoped=true&"
import script from "./mine.vue?vue&type=script&lang=js&"
export * from "./mine.vue?vue&type=script&lang=js&"
import style0 from "./mine.vue?vue&type=style&index=0&id=2bcd7318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd7318",
  null
  
)

export default component.exports